import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-d-flex p-flex-row metaweb-physical-model-accordion-header" }
const _hoisted_2 = { class: "p-ml-auto p-mr-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Listbox = _resolveComponent("Listbox")
  const _component_AccordionTab = _resolveComponent("AccordionTab")
  const _component_Accordion = _resolveComponent("Accordion")

  return (_ctx.meta)
    ? (_openBlock(), _createBlock(_component_Accordion, {
        key: 0,
        multiple: true,
        onTabOpen: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setSelected($event.index))),
        onTabClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setSelected($event.index)))
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.meta.physicalModels, (physicalModel, index) => {
            return (_openBlock(), _createBlock(_component_AccordionTab, { key: index }, {
              header: _withCtx(() => [
                _createVNode("div", _hoisted_1, [
                  _createVNode("span", {
                    "data-test": 'physical-model-tab-' + physicalModel.name 
                  }, _toDisplayString(physicalModel.name), 9, ["data-test"]),
                  _createVNode("span", _hoisted_2, _toDisplayString(physicalModel.columns.length + ' ' + _ctx.$t('common.properties')), 1)
                ])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_Listbox, {
                  class: "metaweb-physical-model-column-listbox",
                  modelValue: _ctx.selectedPhysicalModel,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedPhysicalModel = $event)),
                  options: physicalModel.columns,
                  onChange: _ctx.emitSelectedItem
                }, {
                  option: _withCtx((slotProps) => [
                    _createVNode("div", null, [
                      _createVNode("i", {
                        class: [slotProps.option.primaryKey ? 'fa fa-key gold-key' : 'fa fa-columns', "p-mr-2"]
                      }, null, 2),
                      _createVNode("span", null, _toDisplayString(slotProps.option.name), 1)
                    ])
                  ]),
                  _: 2
                }, 1032, ["modelValue", "options", "onChange"])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}